// extracted by mini-css-extract-plugin
export default {"ShowDeadlines":"ShowDeadlines_ShowDeadlines__njxkQ","list":"ShowDeadlines_list__eNgVr","triangle":"ShowDeadlines_triangle__KE-aE","hLine":"ShowDeadlines_hLine__sR0Tg"};